import ProjectJsonModel          from '@models/map/ProjectJsonModel';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import { documentOfMap }         from '@/TokamapEditor/stores/pairMapsWithDocuments';
import type { TokaMapInstance }  from '@tokamap/core';

export async function reloadCurrentMap(instance: TokaMapInstance): Promise<void> {
	const project = currentProjectEditorStore.get;
	const projectJson = new ProjectJsonModel({ id: project.project.id });

	await projectJson.fetch();

	const documents = (projectJson.json as { maps?: unknown[] })?.maps ?? [];
	const json = documentOfMap(documents, project.currentMap.id);

	if (json) await instance.loadDocument(json, { animateView: false });
}
